export enum AddressType {
  Mailing = 'Mailing',
  Residential = 'Residential',
  Physical = 'Physical',
}
